<section class="bg-gradient auth-view">
  <router-outlet />
</section>
